import { create } from 'zustand'

interface UiState {
  isSearchOpen: boolean
  isMobileMenuOpen: boolean
  isAuthModalOpen: boolean
  authModalMobilePrefill: string
  authModalStartAtOtp: boolean
  setSearchOpen: (open: boolean) => void
  setMobileMenuOpen: (open: boolean) => void
  setAuthModalOpen: (open: boolean) => void
  setAuthModalContext: (context: { mobile?: string; startAtOtp?: boolean }) => void
  clearAuthModalContext: () => void
}

export const useUiStore = create<UiState>((set) => ({
  isSearchOpen: false,
  isMobileMenuOpen: false,
  isAuthModalOpen: false,
  authModalMobilePrefill: '',
  authModalStartAtOtp: false,
  setSearchOpen: (open) => set({ isSearchOpen: open, ...(open ? { isMobileMenuOpen: false } : {}) }),
  setMobileMenuOpen: (open) => set({ isMobileMenuOpen: open, ...(open ? { isSearchOpen: false } : {}) }),
  setAuthModalOpen: (open) => set({ isAuthModalOpen: open }),
  setAuthModalContext: (context) =>
    set({
      authModalMobilePrefill: context.mobile ?? '',
      authModalStartAtOtp: Boolean(context.startAtOtp),
    }),
  clearAuthModalContext: () => set({ authModalMobilePrefill: '', authModalStartAtOtp: false }),
}))
